export const BASE_URL = process.env.REACT_APP_BASE_API || process.env.REACT_APP_API_URL;

if (!BASE_URL) {
  console.warn(
    "⚠️ REACT_APP_BASE_API або REACT_APP_API_URL не встановлено в .env.local файлі!"
  );
}
